import { handleErrors } from '.';

import type { Asset } from '../types/asset';
import type { AssetGroup } from '../types/asset-group';

interface AssetAPIParams {
  page?: number;
  per_page?: number;
  shared?: boolean;
  in_admin?: boolean;
};

interface AssetGroupAPIParams {
  page?: number;
  per_page?: number;
  search?: string;
};

export const APIupdateAsset = async (assetId: string, data: Partial<Asset>) => (
  window.axios.patch(`/api/assets/${assetId}`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeleteAsset = async (assetId: string) => (
  window.axios.delete(`/api/assets/${assetId}`)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdateSprkImage = async (
  assetId: string,
  data: { title: string; groups: string[]; metadata: { hidden: boolean } }
) => (
  window.axios.patch(`/api/assets/${assetId}`, data)
    .then((response) => (response))
    .catch((error) => { throw error.response ? handleErrors(error) : error; })
);

export const APIfetchAssets = async (params: AssetAPIParams) => (
  window.axios.get('/api/assets', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeleteAssetGroup = async (assetGroupId: string) => (
  window.axios.delete(`/api/assets/groups/${assetGroupId}`)
    .then((response) => (response))
    .catch((error) => error)
);

export const APIupdateAssetGroup = async (
  assetGroupId: string,
  data: Pick<AssetGroup, 'name' | 'visible_from' | 'visible_to'>
) => (
  window.axios.patch(`/api/assets/groups/${assetGroupId}`, data)
    .then((response) => (response))
    .catch((error) => { throw error.response ? handleErrors(error) : error; })
);

export const APIcreateAssetGroup = async (data: Pick<AssetGroup, 'name' | 'visible_from' | 'visible_to'>) => (
  window.axios.post('/api/assets/groups', data)
    .then((response) => (response))
    .catch((error) => { throw error.response ? handleErrors(error) : error; })
);

export const APIfetchAssetGroups = async (params: AssetGroupAPIParams = {}) => (
  window.axios.get('/api/assets/groups', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export type SprkImageBulkAction = 'delete' | 'hide' | 'unhide' | 'groups';

export const APIbulkUpdateSprkImages = async (data: {
  action: SprkImageBulkAction;
  ids: string[];
  add_groups?: string[];
  remove_groups?: string[];
}): Promise<{ count: number }> => (
  window.axios.post('/api/assets/bulk', data)
    .then((response) => (response.data))
    .catch((error) => { throw error.response ? handleErrors(error) : error; })
);
